<template>
  <v-menu
    top
    :close-on-content-click="false"
    :open-on-click="false"
    v-model="active"
    offset-y
    bottom
  >
    <template v-slot:activator="{ on, attrs }">
      <v-switch
        :color="color"
        v-on="on"
        v-model="value"
        :disabled="disabled"
        @change="onValueChanged"
      ></v-switch>
    </template>

    <div class="popover">
      <h4 class="mb-1">{{ verb }} en</h4>
      <div class="d-flex align-center">
        <v-btn-toggle dense>
          <v-btn
            color="info"
            @click="changeBranch"
            :disabled="loading === 2"
            :loading="loading === 1"
            >{{ branch.name }}</v-btn
          >
          <v-btn
            color="primary"
            @click="changeAll"
            :disabled="loading === 1"
            :loading="loading === 2"
            >Todas las sucursales</v-btn
          >
        </v-btn-toggle>
      </div>
    </div>
  </v-menu>
</template>

<script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import { IBranch } from '../../interfaces/IBranch';

  @Component
  export default class VisibilitySwitch extends Vue {
    @Prop() visible: boolean;
    @Prop() onlyAll: boolean;
    @Prop() branch: IBranch;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: 'green' }) color: string;
    active = false;
    value = false;

    loading = 0;

    async created() {}

    onValueChanged(newValue: boolean) {
      if (this.visible && !this.onlyAll) {
        this.active = true;
        Vue.nextTick(() => (this.value = !newValue));
      } else {
        this.$emit('changeAll', newValue);
      }
    }

    async changeBranch() {
      this.loading = 1;
      try {
        await (<Function>this.$listeners.changeBranch)(!this.value);
        this.active = false;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = 0;
      }
    }

    async changeAll() {
      this.loading = 2;
      try {
        await (<Function>this.$listeners.changeAll)(!this.value);
        this.active = false;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = 0;
      }
    }

    @Watch('visible', { immediate: true })
    onVisibleChange() {
      this.value = this.visible;
      this.active = false;
    }

    get verb() {
      return this.value ? 'Desactivar' : 'Activar';
    }
  }
</script>

<style scoped lang="scss">
  .popover {
    h4 {
      font-weight: 400;
    }

    .v-btn {
      text-transform: none;
      color: #ffffff;
      font-weight: 400;
    }

    padding: 8px;
    background-color: #ffffff;
  }
</style>
